/** Me → «Новая карта»: form for a chart of another person. */
import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MeSubpageShell } from '../../../components/chrome/MeSubpageShell';
import { PersonForm, createBody, emptyPersonForm, type PersonFormValue } from '../../../components/me/PersonForm';
import { useCreateChart } from '../../../hooks/useCharts';
import { ApiError } from '../../../lib/api-error';

export function ChartNew(): JSX.Element {
  const { t } = useTranslation('me');
  const navigate = useNavigate();
  const create = useCreateChart();
  const [errorCode, setErrorCode] = useState<string | null>(null);
  const [initial] = useState(emptyPersonForm);
  // A double tap lands before `isPending` re-renders the button disabled — guard synchronously.
  const inFlight = useRef(false);

  const submit = async (v: PersonFormValue): Promise<void> => {
    if (inFlight.current) return;
    inFlight.current = true;
    setErrorCode(null);
    try {
      await create.mutateAsync(createBody(v));
      // replace: Back from the list must not return to the filled form.
      navigate('/me/charts', { replace: true });
    } catch (err) {
      setErrorCode(err instanceof ApiError ? err.code : 'unknown');
    } finally {
      inFlight.current = false;
    }
  };

  return (
    <MeSubpageShell title={t('charts.form.newTitle')} data-testid="me-chart-new">
      <PersonForm
        initial={initial}
        submitLabel={t('charts.form.save')}
        busy={create.isPending}
        errorCode={errorCode}
        onSubmit={(v) => void submit(v)}
        onCancel={() => navigate(-1)}
      />
    </MeSubpageShell>
  );
}
